import { configureStore } from '@reduxjs/toolkit';
import authReducer from '../features/auth/authSlice';
import playersReducer from '../features/Players/playersSlice';
import clientsReducer from '../features/Clients/clientsSlice';
import usersReducer from '../features/Users/usersSlice';
import advertisersReducer from '../features/Advertisers/advertisersSlice';

export const store = configureStore({
    reducer: {
        auth: authReducer,
        players: playersReducer,
        clients: clientsReducer,
        users: usersReducer,
        advertisers: advertisersReducer,
    },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
